/**
 * ExportDialog - Dialog for exporting saves
 */

import type { Component } from 'react';
import Dialog from './Dialog';

// React is available globally from CDN
const React = (window as any).React;
const ReactComponent = React.Component;

interface ExportDialogState {
    downloadLink: string;
    filename: string;
    isLoading: boolean;
}

class ExportDialog extends ReactComponent<{ onClose: () => void }, ExportDialogState> {
    private downloadLinkRef: HTMLAnchorElement | null = null;

    constructor(props: { onClose: () => void }) {
        super(props);
        this.state = {
            downloadLink: '',
            filename: '',
            isLoading: true
        };
    }

    componentDidMount(): void {
        void this.prepareExport();
    }

    async prepareExport(): Promise<void> {
        const SavedGames = (window as any).SavedGames;
        if (SavedGames) {
            const filename = SavedGames.titleForSave() + '-saves.json';
            const exportData = (await (window as any).retrieveExportData?.()) ?? '';
            const blob = new Blob([exportData], { type: 'application/json' });
            const url = window.URL.createObjectURL(blob);
            
            this.setState({
                downloadLink: url,
                filename: filename,
                isLoading: false
            }, () => {
                this.triggerDownload();
            });
        }
    }

    triggerDownload(): void {
        if (this.state.downloadLink && this.downloadLinkRef) {
            this.downloadLinkRef.click();
            // Close dialog after a short delay
            setTimeout(() => {
                this.props.onClose();
            }, 500);
        }
    }

    componentWillUnmount(): void {
        if (this.state.downloadLink) {
            window.URL.revokeObjectURL(this.state.downloadLink);
        }
    }

    render(): any {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) return null;

        return React.createElement(DialogComponent, {
            title: 'Export Saves',
            onClose: this.props.onClose,
            actionButtons: React.createElement('button', {
                className: 'btn',
                onClick: this.props.onClose
            }, 'Dismiss'),
            closeOnBackdropClick: false
        },
            React.createElement('div', { style: { textAlign: 'center', padding: '20px' } },
                this.state.isLoading 
                    ? React.createElement('p', { style: { color: 'var(--main-text-color)' } }, 'Preparing export...')
                    : React.createElement(React.Fragment, null,
                        React.createElement('p', { style: { color: 'var(--main-text-color)', marginBottom: '16px' } }, 'Export started. Your file should download automatically.'),
                        React.createElement('a', {
                            ref: (el: HTMLAnchorElement) => { this.downloadLinkRef = el; },
                            href: this.state.downloadLink,
                            download: this.state.filename,
                            style: { display: 'none' }
                        })
                    )
            )
        );
    }
}

(window as any).ExportDialog = ExportDialog;
export default ExportDialog;
